import React, { useState, useEffect } from "react";
import dynamic from 'next/dynamic';
import { Box, Text, Form } from "grommet";
import {
    faCreditCard,
    faLandmark,
} from "@fortawesome/pro-light-svg-icons";
import TabToggle from '../../TabToggle';
import { useRouter } from "next/router";
import { useSWRConfig } from "swr";
import styled from 'styled-components';
const AddPaymentMethodStripeForm = dynamic(() => import("./AddPaymentMethodStripeForm"))

const AddPaymentMethod = ({
    prompt,
    setShowPaymentMethodModal,
    data,
    successCallback,
    onSkip,
    onboardingFlag
}) => {
    const { mutate } = useSWRConfig();
    const [isBank, setIsBank] = useState(true);
    const [options, setOptions] = useState([]);
    const router = useRouter();
    const { token, invited } = router.query; // check to see if the customer is being invited to the page
    const [requireQuickPay, setRequireQuickPay] = useState();

    useEffect(() => {
        const optionsArray = [];
        if (data.customer.bank_debit_processing_enabled) {
            optionsArray.push({name: 'bank account', value: true, icon: faLandmark})
        }
        if (data.customer.card_processing_enabled) {
            if (!optionsArray.length) {
                setIsBank(false);
            }
            optionsArray.push({name: 'credit card', value: false, icon: faCreditCard})
        }
        if (data?.require_quick_pay_on_onboarding) {
            setRequireQuickPay(true);
        }
        setOptions(optionsArray);
    }, [data]);

    const onAddPaymentMethodSuccess = () => {
        if (onboardingFlag) {
            successCallback();
        } else {
            mutate(`/api/customers/application-info?token=${token}`);
            setShowPaymentMethodModal(false);
        }
    };

    return (
        <Box height={{max: '100vh'}} overflow={{vertical: "auto", horizontal: "hidden"}}>
            {prompt && (
                <Box margin={{bottom: "medium"}}>
                    <Text>
                        Add a payment method to your file for quick and easy billing. We'll debit this account when your invoices are due, so you don't have to worry about missed payments.
                    </Text>
                </Box>
            )}
            {options.length > 1 && (
                <StyledBox margin={{bottom: "small"}}>
                    <Form onChange={e => setIsBank(e?.isBank)} value={{isBank}}>
                        <TabToggle
                            name="isBank"
                            options={options}
                            value={isBank}
                        />
                    </Form>
                </StyledBox>
            )}
            <AddPaymentMethodStripeForm
                paymentType={isBank ? 'bank' : 'card'}
                recipientId={data?.customer.id}
                recipientEmailAddress={data?.customer?.billing_address?.email}
                onboardingFlag={onboardingFlag}
                onSkip={onSkip}
                requireQuickPay={requireQuickPay}
                onSuccess={onAddPaymentMethodSuccess}
            />
        </Box>
    );
};

const StyledBox = styled(Box)`
    label {
        display: inline-block;
        width: 50%;
        div {
            display: flex;
            justify-content: center;
        };
    }
`;

export default AddPaymentMethod;
